
<template>
    <ListDialog ref="SalesDeliveryScheduleDialog" :title="$parent.formatTitle('出荷予定表')"  :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SalesDeliveryScheduleReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【出荷予定表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
        <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="出庫倉庫" :editor="editor" :value.sync="warehouse" :needsWarehouse="true" tooltip="ここで倉庫を選択をすると、選択した倉庫だけのデータを出力する事ができます。選択しない場合はすべての倉庫のデータが出力できます。" />
	      <CheckBox title="出荷未定分" :editor="editor" :value.sync="noneScheduledFlag" list="isIncludScheduled" tooltip="出荷予定日が未設定の受注明細を出力するか否かを選択できます。" />
	      <Calendar title="出荷予定日(From)" :editor="editor" :value.sync="deliveryDateFrom"  :autoEntry="true" :dateFlag.sync="deliveryDateFromFlag"  :deletable="false" :required="true" tooltip="データを帳票に出力する出荷予定日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="出荷予定日(To)" :editor="editor" :value.sync="deliveryDateTo" :autoEntry="true" :dateFlag.sync="deliveryDateToFlag" :deletable="false" :required="true" tooltip="データを帳票に出力をする出荷予定日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>               
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesDeliverySchedule extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public noneScheduledFlag: boolean = false;
  public onExcelExport :boolean = false;
  public deliveryDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public deliveryDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){            
    var query: Common.SalesDeliveryScheduleReportTemplateQuery = new Common.SalesDeliveryScheduleReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.noneScheduledFlag = true;
    this.deliveryDateFrom = new Date().getCalendarDate();
    this.deliveryDateTo = new Date().getCalendarDate();

    (this.$refs.SalesDeliveryScheduleDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesDeliveryScheduleReportQuery = new Common.SalesDeliveryScheduleReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.warehouse = this.warehouse;
    query.deliveryDateFrom = this.deliveryDateFrom;
    query.deliveryDateTo = this.deliveryDateTo;
    query.noneScheduledFlag = this.noneScheduledFlag;
    query.salesPurchaseFlag = 1;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
